import { DepositsFilterDto } from '@/services/deposits/deposits-types';
import { SortingState } from '@tanstack/react-table';

export const DEPOSIT_STATUSES = ['CONFIRMED', 'FAILED', 'PENDING'] as const;
export const SUPPORTED_CHAINS = [
  'polygon',
  'bitcoin',
  'solana',
  'base',
  'arbitrum',
  'optimism',
  'avalanche',
  'bnb',
  'binance-smart-chain',
  'ethereum',
] as const;

export type FilterAction =
  | { type: 'SET_FILTERS'; payload: DepositsFilterDto }
  | { type: 'SET_SEARCH'; payload: string }
  | { type: 'SET_STATUS'; payload: string | null }
  | { type: 'SET_CHAIN'; payload: string | null }
  | { type: 'SET_PAGINATION'; payload: { skip: number; take: number } }
  | { type: 'SET_SORTING'; payload: SortingState }
  | { type: 'RESET_FILTERS' };

export interface QueryState {
  filter: DepositsFilterDto;
  skip: number;
  take: number;
  sorting: SortingState;
}

export const initialFilters: DepositsFilterDto = {
  search: undefined,
  status: undefined,
  chain: undefined,
};

export const initialState: QueryState = {
  filter: initialFilters,
  skip: 0,
  take: 25,
  sorting: [],
};

export const queryReducer = (state: QueryState, action: FilterAction): QueryState => {
  switch (action.type) {
    case 'SET_FILTERS':
      return {
        ...state,
        filter: action.payload,
        skip: 0,
      };
    case 'SET_SEARCH':
      return {
        ...state,
        filter: { ...state.filter, search: action.payload },
        skip: 0,
      };
    case 'SET_STATUS':
      return {
        ...state,
        filter: { ...state.filter, status: action.payload as 'CONFIRMED' | 'FAILED' | 'PENDING' | undefined },
        skip: 0,
      };
    case 'SET_CHAIN':
      return {
        ...state,
        filter: { ...state.filter, chain: action.payload || undefined },
        skip: 0,
      };
    case 'SET_PAGINATION':
      return {
        ...state,
        skip: action.payload.skip,
        take: action.payload.take,
      };
    case 'SET_SORTING':
      return {
        ...state,
        sorting: action.payload,
        skip: 0,
      };
    case 'RESET_FILTERS':
      return initialState;
    default:
      return state;
  }
};
